import { useState, useCallback, useContext } from 'react';
import {
  ORGANISATION_KEYS,
  RESTRICT_DATA_DATE,
  SORT,
} from '../../utilities/constants';
import useApiPolling from '../useApiPolling';
import dayjs from 'dayjs';
import { UserRolesAndPermissionsContext } from '../../context/UserRolesAndPermissionsContext';

export const useTableManager = (
  fetchFunction,
  defaultSortKey = '',
  initialFilters = {},
  additionalKeys = null,
  apiPollingEnabled = false
) => {
  const [logsData, setLogsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { userDetails } = useContext(UserRolesAndPermissionsContext);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
      position: ['bottomLeft'],
      showSizeChanger: false,
    },
    filters: initialFilters,
    sort: defaultSortKey ? { [defaultSortKey]: SORT.DESCEND_BE } : {},
    dateRange:
      userDetails?.org === ORGANISATION_KEYS.JPMC
        ? [
            dayjs(RESTRICT_DATA_DATE.JPMC, 'DD-MM-YYYY').format('DD-MM-YYYY'),
            dayjs().subtract(0, 'day').format('DD-MM-YYYY'),
          ]
        : ['', ''],
  });

  const fetchData = useCallback(async () => {
    // Only proceed if both dates are present or both are empty
    if (
      (tableParams?.dateRange[0] && tableParams?.dateRange[1]) ||
      (!tableParams?.dateRange[0] && !tableParams?.dateRange[1])
    ) {
      try {
        setLoading(true);
        const response = await fetchFunction(
          tableParams?.pagination?.current,
          tableParams?.pagination?.pageSize,
          {
            filter: tableParams?.filters,
            sort: tableParams?.sort,
            start_date: tableParams?.dateRange[0],
            end_date: tableParams?.dateRange[1],
            ...(additionalKeys ? additionalKeys : {}),
          }
        );
        setLoading(false);
        return response?.data;
      } catch (error) {
        setLoading(false);
        throw error;
      }
    }
    return null;
  }, [
    fetchFunction,
    tableParams.pagination.current,
    tableParams.pagination.pageSize,
    tableParams.filters,
    tableParams.sort,
    tableParams?.dateRange,
    additionalKeys,
  ]);

  useApiPolling(fetchData, apiPollingEnabled, [tableParams?.pagination]);

  return {
    logsData,
    setLogsData,
    loading,
    tableParams,
    setTableParams,
    fetchData,
  };
};
